import showPlayer from "../libs/zoom-video";

export default context => {
    $('.field-link a[href*="zoom.us/rec/play/"]', context)
        .on('click', function (event) {
            event.preventDefault();
            showPlayer($(this).attr('href'), 'Zoom recording')
            return false
        })
        .attr('aria-haspopup', 'true')
}
